module.exports = __webpack_public_path__ + "img/payment_icon_gpwebpay.5a8797a1.png";